import React, { useState, useCallback } from 'react';
import { Stack } from 'react-bootstrap';
import { RecordField } from '../../types';
import { FieldInput } from '../../../../EmployeeData';
import { FormatFieldValue } from '../../../../../manager/MyTeam/MyTeamChangeRequests/components/FormatFieldValue';
import { Form as CustomForm } from '../../../../../../../components/form/Form';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';

type StepEmployeeDetailsComponentProps = {
  recordFields: Array<RecordField>;
  defaultValues: { [key: string]: string };
  onChange: (fieldData: { [key: string]: string }) => void;
};

const getChangedFields = (
  currentValues: { [key: string]: string },
  originalFields: Array<RecordField>,
): { [key: string]: string } => {
  const changedFields: { [key: string]: string } = {};

  for (const fieldName of Object.keys(currentValues)) {
    const originalField = originalFields.find(
      (field) => field.fieldInfo.name === fieldName,
    );
    const originalValue = originalField?.value || '';
    const newValue = currentValues[fieldName];

    if (newValue.toString() !== originalValue.toString()) {
      changedFields[fieldName] = newValue;
    }
  }
  return changedFields;
};

export const StepEmployeeDetailsComponent: React.FC<
  StepEmployeeDetailsComponentProps
> = ({ recordFields, defaultValues, onChange }) => {
  const t = useNamespacedTranslation('changeRequests.requestForm');
  const [fieldValues, setFieldValues] = useState<{ [key: string]: string }>(
    defaultValues,
  );

  const handleFieldChange = useCallback(
    (value: any, fieldInfo: any) => {
      const updatedValues = { ...fieldValues, [fieldInfo.name]: value };
      setFieldValues(updatedValues);
      const changedFields = getChangedFields(updatedValues, recordFields);
      onChange(changedFields);
    },
    [fieldValues, recordFields, onChange],
  );

  return (
    <Stack gap={0}>
      <div className="mb-4">
        <h4>{t('steps.employeeDetails')}</h4>
        <p className="text-muted">{t('steps.employee_detailsDescription')}</p>
      </div>
      <CustomForm
        onSubmit={() => {}}
        defaultValues={defaultValues}
        isChangeable={true}>
        <div className="fields-section">
          <Stack
            gap={3}
            className="fields-container"
            style={{
              maxHeight: '15rem',
              overflowY: 'auto',
              overflowX: 'hidden',
              padding: '0 0.25rem',
            }}>
            {recordFields.map((field) => (
              <div key={field.fieldInfo.name} className="mb-3">
                <FieldInput
                  fieldInfo={{
                    ...field.fieldInfo,
                    onChange: handleFieldChange,
                  }}
                />
                <div className="text-muted small d-flex gap-2 ms-1 mt-n3">
                  <span>{t('current')}:</span>
                  <span>
                    <FormatFieldValue
                      value={field.value}
                      type={field.fieldInfo.type}
                    />
                  </span>
                </div>
              </div>
            ))}
          </Stack>
        </div>
      </CustomForm>
    </Stack>
  );
};
